import {
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useParams } from "react-router-dom";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useEffect, useState } from "react";
import SelectInputField from "../forms/formElements/SelectInputField";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicAutoComplete from "../ui/BasicAutoComplete";
import { useAppSelector } from "../../redux/hooks";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import { filterConstants } from "../../constants/AppConstants";

export function UpdateUserAccess() {
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { merchantName } = selectedMerchatDetails;
  const [validationState, setValidationState] = useState({
    email: "",
  });
  const shopUserList = useAppSelector(
    (state: any) => state.persistReducers.shopUserSlice?.shopUserList
  );
  const [merchantRoles, setMerchantRoles] = useState<string[]>([]);
  const params = useParams();
  const { userAccessId } = params;

  const singleShopper = shopUserList.filter(
    (shopper: any) => shopper.email === userAccessId
  );
  const shop = singleShopper[0];
  const [status, setStatus] = useState({ status: "" });
  const [merchant, setMerchantState] = useState({ merchant: "" });
  const [first_name, setFirst_name] = useState(shop.first_name);
  const [last_name, setLast_name] = useState(shop.last_name);
  const [email, setEmail] = useState(shop.email);
  const [mobileNumber, setMobileNumber] = useState(shop.mobileNumber);
  const buttonStyles = useButtonStyles();
  const [merchants, setMerchants] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [loadingMerchant, setMerchantLoading] = useState(false);
  const [successMessageForAddShop, setSuccessMessageForAddUser] = useState("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const payload = {
    first_name,
    last_name,
    email,
    mobile: mobileNumber,
    ...status,
    merchantName,
  };
  const updateShopUser = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        process.env.REACT_APP_API_URL + APIConstants.addShopUser,
        payload
      );
      response.data.data && setShowModal(true);
      setSuccessMessageForAddUser(response.data.data);
      setApiSuccess(true);
    } catch (error) {
      console.error(error);
      setShowModal(true);
      setApiSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;
        const roles = data.map((item: any) => {
          return item.name;
        });
        setMerchantRoles(roles);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchRoleList();
  }, []);

  return (
    <Grid>
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        mb={4}
        sx={{ background: theme.color?.background }}
      >
        <Grid display={"flex"} alignItems={"center"} px={4} gap={2}>
          <Link to="/userAccess">
            <ArrowBackIosIcon />
          </Link>{" "}
          <Typography
            variant="h6"
            sx={{
              color: theme?.color?.primary,
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
            }}
          >
            {shop.name}
          </Typography>
        </Grid>
      </Grid>

      <Grid>
        <Grid>
          <Grid
            container
            sx={{
              backgroundColor: theme?.color?.background,
              borderRadius: "8px",
            }}
            width={"80%"}
            margin={3}
            p={3}
            alignSelf={"center"}
          >
            <Grid item container p={4}>
              <Grid item container>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    First Name *
                  </Typography>
                  <TextField
                    type="text"
                    fullWidth
                    size="small"
                    defaultValue={first_name}
                    onChange={(e) => setFirst_name(e.target.value)}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Last Name *
                  </Typography>
                  <TextField
                    type="text"
                    fullWidth
                    size="small"
                    defaultValue={last_name}
                    onChange={(e) => setLast_name(e.target.value)}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Mobile Number *
                  </Typography>
                  <TextField
                    type="number"
                    fullWidth
                    size="small"
                    defaultValue={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  ></TextField>
                </Grid>
              </Grid>

              <Grid container item mt={2}>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Email *
                  </Typography>
                  <TextField
                    fullWidth
                    type="email"
                    size="small"
                    defaultValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  ></TextField>
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Status
                  </Typography>
                  <SelectInputField
                    sx={{ width: "100%" }}
                    setState={setStatus}
                    stateKey="status"
                    defaultValue={shop.status}
                    align="left"
                    options={[
                      filterConstants.Select,
                      filterConstants.Active,
                      filterConstants.Inactive,
                    ]}
                  />
                </Grid>
                <Grid item md={3.5} lg={3.5} mx={1}>
                  <Typography
                    sx={{ fontFamily: theme.font?.fontFamily.primary }}
                  >
                    Role *
                  </Typography>
                  <SelectInputField
                    sx={{ width: "100%" }}
                    setState={setStatus}
                    stateKey="user_role"
                    defaultValue="Tenant Admin"
                    align="left"
                    options={merchantRoles}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item width={"100%"}>
              <Grid
                container
                item
                justifyContent={"end"}
                padding={2}
                borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
                paddingTop={4}
                pr={12}
              >
                <Button
                  sx={{
                    ...buttonStyles.outlinedSecondary,
                    width: "20%",
                    mr: 2,
                  }}
                  variant="outlined"
                  component={Link}
                  to="/admin"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  sx={{ ...buttonStyles.containedSecondary, width: "20%" }}
                  variant="contained"
                  onClick={updateShopUser}
                  startIcon={loading && <CircularProgress size={20} />}
                >
                  {loading ? "Updating..." : "Update"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {showModal && (
            <BasicModal
              title={
                apiSuccess ? successMessageForAddShop : "Something Went Wrong"
              }
              success={apiSuccess}
              setState={setShowModal}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
